/**
 * Created by Ning Jiang on 10/11/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";

import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {Circ, TimelineLite, TweenLite} from "gsap";
import {CreepyCarnivalBetLineEvent} from "../../betline/CCTwoBetlinesView";
import {CCTNineSliceButton} from "../../component/CCTNineSliceButton";
import {CreepyCarnivalTwoGameConfig} from "../../CreepyCarnivalTwoGameConfig";
import {CreepyCarnivalTwoSoundConfig} from "../../CreepyCarnivalTwoSoundConfig";
import {CreepyCarnivalTwoStrings} from "../../CreepyCarnivalTwoStrings";
import {CreepyCarnivalTwoGameMode} from "../../gamemode/CreepyCarnivalTwoGameMode";
import {CreepyCarnivalTwoParsedGameData} from "../../server/data/CreepyCarnivalTwoParsedGameData";
import {CreepyCarnivalTwoParsedInitData} from "../../server/data/CreepyCarnivalTwoParsedInitData";
import {CreepyCarnivalBulbsEvent} from "../../utils/CCTwoBulb";
import {CCTwoFreeSpinEntryEvents} from "./CreepyCarnivalTwoFreespinIntroController";


export interface ICreepyCarnivalTwoFreespinIntroViewConfig extends IScreenViewConfig {
    featureNameTexture?:string,
    amountTexture?:string,
}

export class CreepyCarnivalTwoFreespinIntroView extends ScreenView {

    private _creepyCarnivalconfig:ICreepyCarnivalTwoFreespinIntroViewConfig;
    private _container:PIXI.Container;
    private _introBanner:PIXI.Sprite;
    // // private _timerBG: PIXI.Sprite;
    protected _button:CCTNineSliceButton;
    private _additionalFreeSpinBetLines = CreepyCarnivalTwoGameConfig.instance.BETLINES.filter(function(v, i) {
        // check the index is odd
        return i % 2 == 0;
    });
    private _onShowComplete:any;
    private _timeline:TimelineLite;
    private _youWinText:PIXI.Text;
    private _youWonStyle:TextStyleOptions = {
        fontSize : "20px",
        fill : "#5F99FF",
        fontWeight : '400',
        fontFamily : "Open Sans"
    };
    private _freeSpinTxtStyle:TextStyleOptions = {
        fontSize : "24px",
        fill : "#ABD0FF",
        fontWeight : '700',
        fontFamily : 'Open Sans',
    };
    private _nofreeSpinTxtStyle:TextStyleOptions = {
        fontSize : "26px",
        fill : "#ABD0FF",
        fontWeight : '400',
        fontFamily : 'Open Sans',
    };
    private _freeSpinWonStyle:TextStyleOptions = {
        fontSize : "90px",
        fill : "#ffffff",
        fontWeight : '400',
        fontFamily : 'Insane Rodeo Bold',
    };
    private _anyScatterStyle:TextStyleOptions = {
        fontSize : "20px",
        fill : "#7764FF",
        fontWeight : '400',
        fontFamily : 'Open Sans',
    };
    private _freeSpinsText:PIXI.Text;
    private _freeSpinsmultipliertext:PIXI.Text;
    private _FSExtraFreeSpinsText:PIXI.Text;
    private _FSScatterText:PIXI.Text;
    private _freeSpinsBetlinesText:PIXI.Text;
    private _introFrame:PIXI.Sprite;
    private _introFrameContainer:PIXI.Container;
    private _noOfFreeSpins:PIXI.Text;
    private _introBannerContainer:PIXI.Container;
    private _timelineIntroBanner:TimelineLite;
    private _freeSpinLeft:any;
    private _nofreeSpinsText:any;
    private _isRestore:boolean;
    private retriggeredSpins:any;
    private _playedBanner:boolean;
    private _reelScatterSpots:number[];

    private _mode:string = "";

    constructor(config:ICreepyCarnivalTwoFreespinIntroViewConfig, autoClose:boolean = false) {
        super(config, autoClose);
        this._creepyCarnivalconfig = config;
        this._isRestore = false;
    }

    protected createGameGraphics():PIXI.DisplayObject {

        this._container = new PIXI.Container();
        const introFrameContainer:PIXI.Container = new PIXI.Container();
        const introBannerContainer:PIXI.Container = new PIXI.Container();
        this._introBanner = new PIXI.Sprite(GameResources.getTextures("curtain_fs")[0]);
        this._introFrame = new PIXI.Sprite(GameResources.getTextures("assets/fs_frame")[0]);
        let bannerMask = new PIXI.Graphics();
        bannerMask.beginFill(0xFFFFFF, 1);
        bannerMask.drawRect(-385, -260, 800, 700);
        bannerMask.endFill();
        this._container.addChild(bannerMask);
        introBannerContainer.mask = bannerMask;
        this._introBanner.anchor.set(0.5);
        this._introFrame.anchor.set(0.5);
        this._introBanner.position.set(-10, 0);
        this._introBanner.scale.set(1.001, 1);

        // this._timerBG = new PIXI.Sprite(GameResources.getTextures("assets/timerBG")[0]);
        // this._timerBG.anchor.set(0.5);
        // this._timerBG.scale.set(1, 0.8);
        // this._timerBG.position.set(0, 242);
        // this._timerBG.alpha = 0;

        introBannerContainer.addChild(this._introBanner);
        // // introBannerContainer.addChild(this._timerBG);
        introFrameContainer.addChild(this._introFrame);

        this._noOfFreeSpins = new PIXI.Text("0", this._freeSpinWonStyle);
        this._noOfFreeSpins.anchor.set(0.5);

        this._noOfFreeSpins.position.set(0, -85);
        introFrameContainer.position.set(0, -15);
        introFrameContainer.addChild(this._noOfFreeSpins);

        this._youWinText = new PIXI.Text(` ${Translation.translate(CreepyCarnivalTwoStrings.FS_YOU_WON_TEXT)} `, this._youWonStyle);
        this._youWinText.anchor.set(0.5);
        this._youWinText.position.set(0, -72);
        introBannerContainer.addChild(this._youWinText);

        this._nofreeSpinsText = new PIXI.Text(this._freeSpinLeft, this._nofreeSpinTxtStyle);
        this._nofreeSpinsText.anchor.set(0.5);
        this._nofreeSpinsText.position.set(-80, -38);

        this._freeSpinsText = new PIXI.Text(` ${Translation.translate(CreepyCarnivalTwoStrings.NUMBER_OF_SPINS_WON_TEXT)} `, this._freeSpinTxtStyle);
        this._freeSpinsText.anchor.set(0.5);
        this._freeSpinsText.position.set(0, -40);
        this._freeSpinsText.skew.set(0, -0.05);

        introBannerContainer.addChild(this._freeSpinsText);
        introBannerContainer.addChild(this._nofreeSpinsText);

        this._freeSpinsmultipliertext = new PIXI.Text(` ${Translation.translate(CreepyCarnivalTwoStrings.FS_MULTIPLIER_TEXT)} `, this._youWonStyle);
        this._freeSpinsmultipliertext.anchor.set(0.5);
        this._freeSpinsmultipliertext.position.set(0, -5);
        this._freeSpinsmultipliertext.skew.set(0, 0.04);
        introBannerContainer.addChild(this._freeSpinsmultipliertext);

        this._freeSpinsBetlinesText = new PIXI.Text(` ${Translation.translate(CreepyCarnivalTwoStrings.FS_BETLINES_TEXT)} `, this._youWonStyle);
        this._freeSpinsBetlinesText.anchor.set(0.5);
        this._freeSpinsBetlinesText.position.set(0, 30);
        this._freeSpinsBetlinesText.skew.set(0, 0.04);
        introBannerContainer.addChild(this._freeSpinsBetlinesText);

        this._FSScatterText = new PIXI.Text(` ${Translation.translate(CreepyCarnivalTwoStrings.FS_SCATTER_TEXT)} `, this._anyScatterStyle);
        this._FSScatterText.anchor.set(0.5);
        this._FSScatterText.position.set(0, 65);
        this._FSScatterText.skew.set(0, -0.04);
        introBannerContainer.addChild(this._FSScatterText);

        this._FSExtraFreeSpinsText = new PIXI.Text(` ${Translation.translate(CreepyCarnivalTwoStrings.FS_EXTRA_FREESPINS_TEXT)} `, this._anyScatterStyle);
        this._FSExtraFreeSpinsText.anchor.set(0.5);
        this._FSExtraFreeSpinsText.position.set(0, 100);
        this._FSExtraFreeSpinsText.skew.set(0, -0.04);
        introBannerContainer.addChild(this._FSExtraFreeSpinsText);

        this._container.addChild(introBannerContainer);
        this._container.addChild(introFrameContainer);
        // this._container.addChild(this._timerBG);
        this._introFrameContainer = introFrameContainer;
        this._introBannerContainer = introBannerContainer;
        this._introBannerContainer.visible = false;
        this._introFrameContainer.alpha = 0;
        return this._container;
    }

    protected startPresentation(data?:ParsedServerData, onShowComplete?:() => void):void {
        // this._autoCloseTimer.visible = false;
        if(this._freeSpinLeft) {
            this._noOfFreeSpins.text = this._freeSpinLeft;
            this._nofreeSpinsText.text = this._freeSpinLeft;
        }
        if(this._isRestore) {
            this._introFrameContainer.alpha = 0;
            this.playIntroBannerAnimation(onShowComplete);
        } else {
            EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBulbsEvent.BLINKING_EFFECT_BULBS));
            EventHandler.dispatchEvent(new GameEvent(CCTwoFreeSpinEntryEvents.SCATTER_WIGGLE_ANIM, this._reelScatterSpots));
            const timeline:TimelineLite = new TimelineLite();

            if(this._mode === "STAR_SPIN") {
                timeline.add(() => {
                    this.playFreeSpinTriggeredAnimation(this._freeSpinLeft, onShowComplete)
                }, 1);
            } else {
                timeline.add(() => {
                    this.playFreeSpinTriggeredAnimation(this._freeSpinLeft, onShowComplete)
                }, 0);
            }
        }
    }

    protected playIntroBannerAnimation(onShowComplete?:() => void) {
        EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBulbsEvent.KILL_BLINKING_EFFECT_BULBS));

        if(!this._timelineIntroBanner) {
            const bannerTimeline:TimelineLite = new TimelineLite({paused : true});

            bannerTimeline.add(() => {
                this._introBannerContainer.visible = true;
                TweenLite.fromTo(this._introBannerContainer, 1, {y : -800}, {y : -25, ease : Circ.easeOut});
                EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : CreepyCarnivalTwoGameMode.FREESPIN}));
                SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.FS_INTRO);
            }, 0);

            bannerTimeline.add(() => {
                this._button.visible = true;
                // this._autoCloseTimer.visible = true;
                EventHandler.dispatchEvent(new GameEvent(CCTwoFreeSpinEntryEvents.RESET_MULTIPLIER, true));//, multiplierTimeline));
            }, 1.1);

            bannerTimeline.add(() => {
                this._playedBanner = true;
                if(onShowComplete) {
                    onShowComplete();
                    // this._timerBG.alpha = 1;
                    // this._autoCloseTimer.visible = true;
                }
            });
            this._timelineIntroBanner = bannerTimeline;
        }
        this._timelineIntroBanner.play(0);

    }

    protected createButton():CCTNineSliceButton {
        const text:string = Translation.translate(this._config.buttonText ? this._config.buttonText : "CONTINUE");
        const textStyle:TextStyleOptions = this.getScaledButtonTextStyle();
        const button = new CCTNineSliceButton(() => this.onButtonClick(), ` ${text} `, textStyle, this._config.buttonBackgroundConfig);
        button.enabled = false;
        button.visible = false;
        if(UserAgent.isMobile) {
            button.scale.set(1.2);
        }
        return button;
    }

    /**
     * Commented below function as this was creating the issue of intro stuck. #150
     * @param resizeData
     */
    protected onResizeGameGraphics(resizeData:IResizeData):void {
        this._container.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);

        // this._timerBG.width = this._autoCloseTimer.width + 50;
        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._container.x = (this._container.x + 10);
            this._container.y = (this._container.y + 3);
        } else if(UserAgent.isMobile) {
            this._container.x = (this._container.x + 10);
            this._container.y = (this._container.y - 10);
        } else {
            this._container.x = (this._container.x + 10);
            this._container.y = (this._container.y - 10);
        }
    }

    protected stopPresentation(closeCallback?:() => void):void {
        const timeline:TimelineLite = new TimelineLite({paused : true});
        const tmelneStpPrstation:TimelineLite = new TimelineLite({paused : true});
        const _super = super.stopPresentation;
        const _this = this;
        let TimelineCollab:TimelineLite = new TimelineLite({
            paused : true, onComplete : () => {
                tmelneStpPrstation.add(() => {
                    _super.call(_this, closeCallback);
                }, 0.5);
                tmelneStpPrstation.play(0);
            }
        });
        timeline.add(() => {
            this._button.visible = false;
            // this._autoCloseTimer.visible = false;
            // // this._timerBG.alpha = 0;
        });
        timeline.add([
            TweenLite.fromTo(this._introBannerContainer, 1, {y : -27}, {y : -800, ease : Circ.easeOut}),
        ]);
        timeline.add(() => {
            this._introBannerContainer.visible = false;
            if(this._timeline)
                this._timeline.kill();
            if(this._timelineIntroBanner)
                this._timelineIntroBanner.kill();
            let data = {x : this._additionalFreeSpinBetLines, y : TimelineCollab};

            SlotGame.sound.fadeAmbience(1, 0);
            SlotGame.sound.playAmbience(CreepyCarnivalTwoSoundConfig.instance.BONUS_GAME_AMBIANCE);

            EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBetLineEvent.SHOW_FREE_SPIN_ALL_BET_LINES, data));
        });
        timeline.play(0);

    }

    protected addEventListeners() {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, CCTwoFreeSpinEntryEvents.ENTER_IN_FREE_SPIN, (event:GameEvent) => this.onEntryInFreeSpin());
        EventHandler.addEventListener(this, CCTwoFreeSpinEntryEvents.SHOW_FREE_SPIN_WON, (event:GameEvent) => this.playFreeSpinTriggeredAnimation(event.params[0]));
        EventHandler.addEventListener(this, CCTwoFreeSpinEntryEvents.FRAME_ANIM_COMPLETED, (event:GameEvent) => this.onFrameAnimComplete(event.params[0]));
    }

    private playFreeSpinTriggeredAnimation(freeSpinCounter:string, onShowComplete?:() => void) {
        if(this._freeSpinLeft) {
            this._noOfFreeSpins.text = this._freeSpinLeft;
        }
        if(onShowComplete) {
            this._onShowComplete = onShowComplete;
        }
        if(this.retriggeredSpins) {
            this.name = "freeSpinTrigger";
            if(!this._layer.getChildByName("freeSpinTrigger")) {
                this._layer.addChild(this);
            }
            EventHandler.dispatchEvent(new GameEvent(CCTwoFreeSpinEntryEvents.SCATTER_WIGGLE_ANIM, this._reelScatterSpots));
            SlotGame.keypad.setZeroBetSpinCounter(this._freeSpinLeft);
            this._noOfFreeSpins.text = freeSpinCounter;
            SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.EXTRA_SPIN);
        }
        if(!this._playedBanner && this.retriggeredSpins) {
            this._introFrameContainer.setTransform(610, 350);

        } else {
            this._introFrameContainer.setTransform(0, 0);
        }
        if(!this._timeline) {
            this._introBannerContainer.visible = false;
            this._introFrameContainer.alpha = 0;

            const timeline:TimelineLite = new TimelineLite({paused : true});
            timeline.add([
                TweenLite.fromTo(this._introFrameContainer, 0.1, {alpha : 0}, {alpha : 1}),
            ], 0);

            // added free spin win sound, #199
            timeline.add(() => {
                if(this._mode === CreepyCarnivalTwoGameMode.NORMAL) {
                    SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.FREESPIN_WIN);
                }
            }, 0);

            timeline.add([
                TweenLite.fromTo(this._introFrameContainer.scale, 0.2, {x : 1, y : 1}, {x : 1.1}),
            ], 1);
            timeline.add([
                TweenLite.fromTo(this._introFrameContainer.scale, 0.5, {x : 1.1, y : 1}, {x : 0.9, y : 1}),
            ], 1.4);
            timeline.add([
                TweenLite.fromTo(this._noOfFreeSpins, 0.5, {alpha : 1}, {alpha : 0.4}),
            ], 1.4);
            timeline.add([
                TweenLite.fromTo(this._introFrameContainer.scale, 0.3, {x : 0.9}, {x : 0}),
            ], timeline.totalDuration() - 0.1);
            timeline.add(() => {
                EventHandler.dispatchEvent(new GameEvent(CCTwoFreeSpinEntryEvents.FRAME_ANIM_COMPLETED, this._onShowComplete));
            }, timeline.totalDuration() + 2);
            this._timeline = timeline;
        }
        if(!this._timeline.isActive()) {
            this._timeline.play(0);
        }
    }

    private onFrameAnimComplete(onShowComplete?:() => void) {
        EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBulbsEvent.KILL_BLINKING_EFFECT_BULBS));
        if(this.retriggeredSpins) {
            this._layer.removeChild(this);
            this._introFrameContainer.setTransform(0, 0);
            SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.FS_ADD_SPINS);
        } else {
            this.playIntroBannerAnimation(onShowComplete);
        }
    }

    private onServerDataParsed(data:CreepyCarnivalTwoParsedInitData):void {
        if(data.restore) {
            this._isRestore = true;
        }
    }

    private onGameDataParsed(data:CreepyCarnivalTwoParsedGameData):void {
        this._mode = data.mode;

        this._freeSpinLeft = data.freespinsLeft;
        this._reelScatterSpots = [];
        let scatterPositions:any[] | undefined;
        this.retriggeredSpins = data.extraFreespinsAwarded();
        scatterPositions = data.scatterPositions;
        scatterPositions = scatterPositions ? scatterPositions.reduce((acc, currEl) => acc.concat(currEl), []) : [];
        for(let i = 0; i < scatterPositions!.length; i++) {
            scatterPositions![i] && this._reelScatterSpots.push(i);
        }
    }

    private onEntryInFreeSpin():void {
        if(this._isRestore) {
            this._isRestore = false;

            // switch to free spin ambiance sound
            SlotGame.sound.fadeAmbience(1, 0);
            SlotGame.sound.playAmbience(CreepyCarnivalTwoSoundConfig.instance.BONUS_GAME_AMBIANCE);

            EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBetLineEvent.SHOW_ALL_BET_LINES, this._additionalFreeSpinBetLines));
        }
    }
}